import React, {
    useState,
    useEffect,
    useContext,
    useCallback
} from 'react';
import _ from 'lodash';
import appConfig from 'app-config';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { MLBundleService, MLPortalStorageService } from 'ml-services-common-react';
import { LoadSaveService } from 'gw-capability-quoteandbind';
import { MLModalService } from 'ml-portals-services-react';
import { platformMessages } from 'ml-components-platform-react';
import {MLNotificationBlockUtil, MLDriverVehicleUtil, MLWizardNavUtil} from 'ml-portals-util-react';
import { MLDisclosureUtil } from 'ml-portals-util-js';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import wizardConfig from "../../config/pup-wizard-config.json5";

import PUPVehicleInfoComponent from '../../components/PUPVehicleInfoComponent/PUPVehicleInfoComponent';
import PUPAddtlInterestDriverComponent from '../../components/PUPAddtlInterestDriverComponent/PUPAddtlInterestDriverComponent';
import PUPHouseholdDriverComopnent from '../../components/PUPHouseholdDriverComponent/PUPHouseholdDriverComponent';
import AddtlInterestWatercraftOpComponent from '../../components/AddtlInterestWatercraftOpComponent/AddtlInterestWatercraftOpComponent';
import metadata from './PUPAdditionalInformationPreBindPage.metadata.json5';
import messages from './PUPAdditionalInformationPreBindPage.messages';
import { ScrollToError } from '@jutro/legacy/wizard-next';

const {
    ML_STORAGE_KEY_PREVIOUS_PREMIUM
} = appConfig;

// MLPUPAddtlDetailsCtrl.js, ml-pup-addtl-details.html
function PUPAdditionalInformationPreBindPage(props) {
    const translator = useTranslator();
    const { authHeader } = useAuthentication();
    const { wizardData: submissionVM, updateWizardData, steps, changeNextSteps } = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const [showErrors, updateShowErrors] = useState(false);
    const [errorTimestamp, setErrorTimestamp] = useState(0);
    const [additionalInterestAvailableCandidatesML, setAdditionalInterestAvailableCandidatesML] = useState([]);
    const {
        onValidate
    } = useValidation('PUPAdditionalInformationPreBindPage');

    const { steps: wizardSteps } = wizardConfig;

    const {
        showProgressDialog,
        hideProgressDialog
    } = MLModalService();

    const {
        addErrorAlert,
        clearBlockAlerts
    } = MLNotificationBlockUtil();

    const {
        checkHiDrivers,
        checkPendingMvrOrderStatus,
    } = MLDriverVehicleUtil();

    const {nextStepVisited} = MLWizardNavUtil(props);

    const pupModel = _.get(submissionVM, 'lobData.personalUmbrella');
    const pupVehicles = _.get(pupModel, 'coverables.vehicles.children', []);
    const pupVehicleOperators = _.get(pupModel, 'coverables.vehicleOperators.children', []);
    const pupWatercraftOperators = _.get(pupModel, 'coverables.watercraftOperators.children', [])
    const isBundle = submissionVM.isBundle_ML.value;

    useEffect(() => {
        LoadSaveService.getAdditionalInterestCandidatesML(submissionVM.quoteID.value, authHeader).then((candidates) => {
            setAdditionalInterestAvailableCandidatesML(candidates);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const isDriver = (vehicleOperatorVM) => {
        const driverType = _.get(vehicleOperatorVM, 'driverType.value.code');
        switch (driverType) {
            case 'rated':
            case 'excluded':
                return true;
            default:
                return false;
        }
    };

    const isExcludedDriverEmail = () => {
        if (isexcluded && isInVA()){
            return false
        }
        return true
    };

    const isSpouseDriver = (vehicleOperatorVM) => {
        return _.get(vehicleOperatorVM, 'relationshipToInsured.value.code') === 'spouse';
    };

    const isInCO = useCallback(() => {
        return submissionVM.baseData.policyAddress.state.value.code === 'CO';
    }, [submissionVM.baseData.policyAddress.state.value.code]);

    const isExcludedDriver = (vehicleOperatorVM) => {
        return _.get(vehicleOperatorVM, 'driverType.value.code') === 'excluded';
    };

    const isInGA = () => {
        return submissionVM.baseData.policyAddress.state.value.code === 'GA';
    };

    const isInUT = () => {
        return submissionVM.baseData.policyAddress.state.value.code === 'UT';
    };

    const isInOR = () => {
        return submissionVM.baseData.policyAddress.state.value.code === 'OR';
    };

    const isInVA = () => {
        return submissionVM.baseData.policyAddress.state.value.code === 'VA';
    };
    
    const isexcluded = pupVehicleOperators.find((vehicleOperatorVM) => vehicleOperatorVM.driverType.value.code == 'excluded')

    const isRatedDriver = pupVehicleOperators.find((vehicleOperatorVM) => vehicleOperatorVM.driverType.value.code === 'rated');

    const initVehicleOperator = (vehicleOperatorVM) => {
        _.set(vehicleOperatorVM, 'contact.updated.value', true);
        _.set(vehicleOperatorVM, 'isAgeFirstLicensedRequired.value', true);
        _.set(vehicleOperatorVM, 'isOccupationTypeRequired.value', true);
        _.set(vehicleOperatorVM, 'isEmailAddressRequired.value', vehicleOperatorVM.isPrimaryNamedInsured.value ? vehicleOperatorVM.commPreference.value.code === 'electronic' : false);

        if (isDriver(vehicleOperatorVM)) {
            _.set(vehicleOperatorVM, 'isLicenseNumberRequired.value', true);
            _.set(vehicleOperatorVM, 'isLicenseStateRequired.value', true);
            if ((isSpouseDriver(vehicleOperatorVM) && isInCO())
                || (isExcludedDriver(vehicleOperatorVM) && (isInGA() || isInUT()))) {
                _.set(vehicleOperatorVM, 'isEmailAddressRequired.value', true);
            }
            if(isexcluded && vehicleOperatorVM.relationshipToInsured.value.code === 'spouse' && isInOR()) {
                _.set(vehicleOperatorVM, 'isEmailAddressRequired.value', true);                
            }
        } else {
            _.set(vehicleOperatorVM, 'isLicenseNumberRequired.value', false);
            _.set(vehicleOperatorVM, 'isLicenseStateRequired.value', false);
        }
        _.set(vehicleOperatorVM, 'isHasLossWithin5YearsRequired.value', !!vehicleOperatorVM.isPrimaryNamedInsured.value);
        _.set(vehicleOperatorVM, 'value.hasEmailAddressInput', !!vehicleOperatorVM.emailAddress.value);
        return vehicleOperatorVM;
    };
    
    const vehicleOperatorsVM = pupVehicleOperators.filter((vehicleOperatorVM) => initVehicleOperator(vehicleOperatorVM))

    useEffect(() => {
        const prefillBundleInfoPUPData = () => {
            const driversCandidate = MLBundleService.getPrefillDriversCandidate();
            if (driversCandidate && driversCandidate.driverDetails) {
                vehicleOperatorsVM.forEach((operatorVM) => {
                    const prefillFrom = driversCandidate.driverDetails.find((candidate) => candidate.publicID === operatorVM.contact.publicID.value);
                    if (prefillFrom) {
                        operatorVM.occupationType.value = operatorVM.occupationType.value || prefillFrom.occupation_Ext;
                        operatorVM.licenseNumber.value = operatorVM.licenseNumber.value || prefillFrom.licenseNumber;
                        operatorVM.ageFirstLicensed.value = operatorVM.ageFirstLicensed.value || prefillFrom.ageFirstLicensed_ML;
                    }
                });
            }
        };

        if (isBundle) {
            prefillBundleInfoPUPData();
        }
    }, [isBundle, vehicleOperatorsVM])

    const driversVM = vehicleOperatorsVM.filter((driver) => {
        return _.get(driver, 'driverType.value.code') === 'rated';
    });
    const excludedDriversVM = vehicleOperatorsVM.filter((driver) => {
        return _.get(driver, 'driverType.value.code') === 'excluded';
    });
    const householdMembersVM = vehicleOperatorsVM.filter((driver) => {
        return _.get(driver, 'driverType.value.code') === 'household';
    });

    const initWatercraftOperator = (watercraftOperatorVM) => {
        // _.set(watercraftOperatorVM, 'isYearsOfExperienceRequired.value', true);
        return watercraftOperatorVM;
    };
    const watercraftOperatorsVM = pupWatercraftOperators.filter(
        (watercraftOperatorVM) => initWatercraftOperator(watercraftOperatorVM)
    );

    const [vehiclesVM, setVehiclesVM] = useState([]);

    const isVehiclePrivateOrClassic = (vehicleVM) => {
        switch (vehicleVM.type.value.code) {
            case 'private_passenger_autos_ml':
            case 'classic_ml':
                return true;
            default:
                return false;
        }
    };

    const isCategoryTrailerGolfCartOrLowSpeedOrOtherPersonal = (vehicleVM) => {
        switch (vehicleVM.type.value.code) {
            case 'trailer_ml':
            case 'GolfCart_ML':
            case 'LowSpeed_ML':
            case 'Other_Personally_Registered':
                return true;
            default:
                return false;
        }
    };

    const isVinNoLookupVehicleType = (vehicleVM) => {
        switch (vehicleVM.type.value.code) {
            case 'Motorcycle':
            case 'vans_suvs_ml':
            case 'pickups_ml':
            case 'atv_snowmobile_ml':
                return true;
            default:
                return false;
        }
    };

    useEffect(() => {
        const initVehiclesVM = () => {
            const filteredVehicles = pupVehicles.filter((vehicle) => {
                return vehicle.namedNonOwner_ML.value || isVehiclePrivateOrClassic(vehicle)
                    || isCategoryTrailerGolfCartOrLowSpeedOrOtherPersonal(vehicle) || isVinNoLookupVehicleType(vehicle);
            });

            return filteredVehicles.map((vehicleVM) => {
                if (vehicleVM.namedNonOwner_ML.value) {
                    return vehicleVM;
                }
                _.set(vehicleVM, 'isVinRequired_ML.value', true);
                return vehicleVM;
            });
        };

        setVehiclesVM(initVehiclesVM());
    }, [pupVehicles]);

    const updateSubmissionVM = useCallback(() => {
        updateWizardData(submissionVM);
    }, [submissionVM, updateWizardData]);

    const isVinDuplicated = useCallback((currentVehicle) => {
        const vehicleVin = currentVehicle.vin;
        const vehiclesWithTheSameVin = vehiclesVM.filter(
            (x) => !_.isUndefined(x.vin.value) && x.vin.value === vehicleVin.value
        );
        return vehiclesWithTheSameVin.length >= 2;
    }, [vehiclesVM]);

    const writeValue = useCallback((value, path) => {
        const newSubmissionVM = viewModelService.clone(submissionVM);
        _.set(newSubmissionVM, path, value);
        updateWizardData(newSubmissionVM);
    }, [submissionVM, updateWizardData, viewModelService]);

    const generateVehiclesOverrides = useCallback(() => {
        const pupVehiclesValue = _.get(pupModel, 'coverables.vehicles.value', []);
        const overrides = vehiclesVM.map((vehicle, index) => {
            const vehicleIndex = _.findIndex(
                pupVehiclesValue,
                ({ publicID }) => publicID === vehicle.publicID.value
            );
            return {
                [`pupVehicleInfoComponent${index}`]: {
                    value: vehicle,
                    isVinDuplicated,
                    index,
                    vehicleIndex,
                    onValueChange: writeValue,
                    quoteID: submissionVM.quoteID,
                    updateVehicleDetails: updateSubmissionVM,
                    showValidationErrors: showErrors,
                    onValidate,
                    isVehiclePrivateOrClassic,
                    isCategoryTrailerGolfCartOrLowSpeedOrOtherPersonal,
                    isVinNoLookupVehicleType,
                    path: `lobData.personalUmbrella.coverables.vehicles.children.${vehicleIndex}`,
                }
            };
        });

        return Object.assign({}, ...overrides);
    }, [
        isVinDuplicated,
        onValidate,
        pupModel,
        showErrors,
        submissionVM.quoteID,
        updateSubmissionVM,
        vehiclesVM,
        writeValue
    ]);

    const generateDriversOverrides = useCallback(() => {
        const driversPath = 'lobData.personalUmbrella.coverables.vehicleOperators.children';
        const drivers = _.get(submissionVM, driversPath, []);

        const getIndexFromDriverList = (specificDriver) => {
            const driverIndex = drivers.indexOf(specificDriver);
            return driverIndex;
        };

        const ratedOverrides = driversVM.map((driver, index) => {
            return {
                [`ratedDriverComponent${index}`]: {
                    value: driver,
                    index,
                    path: `${driversPath}.${getIndexFromDriverList(driver)}`,
                    onValueChange: writeValue,
                    showValidationErrors: showErrors,
                    onValidate,
                    isRatedDriver: isRatedDriver
                }
            };
        });

        const excludedOverrides = excludedDriversVM.map((driver, index) => {
            return {
                [`excludedDriverComponent${index}`]: {
                    value: driver,
                    index,
                    path: `${driversPath}.${getIndexFromDriverList(driver)}`,
                    onValueChange: writeValue,
                    showValidationErrors: showErrors,
                    onValidate,
                    isExcludedDriver: isExcludedDriverEmail()
                }
            };
        });

        const householdOverrides = householdMembersVM.map((driver, index) => {
            return {
                [`householdDriverComponent${index}`]: {
                    value: driver,
                    index,
                    path: `${driversPath}.${getIndexFromDriverList(driver)}`,
                    onValueChange: writeValue,
                    showValidationErrors: showErrors,
                    onValidate,
                    isDriver
                }
            };
        });
        return Object.assign({}, ...ratedOverrides, ...excludedOverrides, ...householdOverrides);
    }, [
        driversVM,
        excludedDriversVM,
        householdMembersVM,
        onValidate,
        showErrors,
        submissionVM,
        writeValue
    ]);

    const generateWatercraftOperatorsOverride = useCallback(() => {
        const watercraftOperatorPath = 'lobData.personalUmbrella.coverables.watercraftOperators.children';
        const overrides = watercraftOperatorsVM.map((watercraft, index) => {
            return {
                [`addtlInterestWatercraftOpComponent${index}`]: {
                    value: watercraft,
                    index,
                    path: `${watercraftOperatorPath}.${index}`,
                    onValueChange: writeValue,
                    showValidationErrors: showErrors,
                    onValidate
                }
            };
        });

        return Object.assign({}, ...overrides);
    }, [onValidate, showErrors, watercraftOperatorsVM, writeValue]);

    const generateLiabilityLossesOverride = useCallback(() => {
        const driversPath = 'lobData.personalUmbrella.coverables.vehicleOperators.children';
        const drivers = _.get(submissionVM, driversPath, []);
        const getIndexFromDriverList = (specificDriver) => {
            const driverIndex = drivers.indexOf(specificDriver);
            return driverIndex;
        };

        const updateVehicleOperator = (value, path) => {
            _.set(submissionVM, path, value);
            updateSubmissionVM();
        };

        const overrides = vehicleOperatorsVM.map((vehicleOperator, index) => {
            const obj = {
                [`liabilityLossContainer${index}`]: {
                    visible: vehicleOperator.isPrimaryNamedInsured.value === true
                }
            };
            if(vehicleOperator.isPrimaryNamedInsured.value === true){
                obj.liabilityLossRadioButton = {
                    id: `liabilityLossRadioButton${index}`,
                    path: `${driversPath}.${getIndexFromDriverList(vehicleOperator)}.hasLossWithin5Years`,
                    value: _.get(vehicleOperator, 'hasLossWithin5Years.value'),
                    onValueChange: updateVehicleOperator
                }
            }
            return obj;
        });

        return Object.assign({}, ...overrides);
    }, [submissionVM, updateSubmissionVM, vehicleOperatorsVM]);

    const isPrimaryDriver = (vehicleOperatorVM) => {
        return _.get(vehicleOperatorVM, 'relationshipToInsured.value.code') === 'self';
    };

    const evaluateSpouseEmailAddressesInColorado = useCallback(() => {
        const primaryDriverSpouse = vehicleOperatorsVM.filter((driver) => {
            return isSpouseDriver(driver);
        });
        const primaryDriverSpouseEmail = primaryDriverSpouse[0] ? primaryDriverSpouse[0].emailAddress : null;
        const primaryDriver = vehicleOperatorsVM.find((driver) => isPrimaryDriver(driver));
        const primaryDriverEmail = primaryDriver ? primaryDriver.emailAddress : undefined;
        return isInCO() && !!primaryDriverSpouseEmail
            && primaryDriverEmail
            && primaryDriverSpouseEmail.value === primaryDriverEmail.value;
    }, [isInCO, vehicleOperatorsVM]);

    const evaluateDuplicatesInVehicleOperators = useCallback(() => {
        if (vehicleOperatorsVM.length > 1) {
            const emailAddresses = vehicleOperatorsVM
                .map((vehicleOperator) => vehicleOperator.emailAddress.value)
                .filter((address) => !!address);
            return emailAddresses.filter((address, index) => emailAddresses.indexOf(address) !== index).length > 0;
        }
        return false;
    }, [vehicleOperatorsVM]);

    const isVinValid = useCallback((vehicleVM) => {
        const vin = _.get(vehicleVM, 'vin');
        const vinIntegrationInvalidCodes = ['5', '4', 'N', '6', 'S', 'L', 'X'];
        const vinIntegrationErrorCode = _.get(vehicleVM, 'vinIntegrationErrorCode_ML');
        const vinIntegrationErrorCodeVal = _.get(vehicleVM, 'vinIntegrationErrorCode_ML.value');
        const vinIntegrationValid = !vinIntegrationErrorCode || (vinIntegrationErrorCodeVal
            && vinIntegrationInvalidCodes.indexOf(vinIntegrationErrorCodeVal) === -1);

        return vin.aspects.valid && vinIntegrationValid && !isVinDuplicated(vehicleVM);
    }, [isVinDuplicated]);

    const shouldShowDisclosures = useCallback(() => {
        const getSelectedQuote = () => {
            const selectedQuoteId = _.get(submissionVM, 'bindData.chosenQuote.value');
            const offeredQuotes = _.get(submissionVM, 'quoteData.offeredQuotes.value', []);
            return offeredQuotes.find((q) => q.publicID === selectedQuoteId);
        };

        let violations = [];
        const selectedQuote = getSelectedQuote();
        if (selectedQuote === undefined) {
            return false;
        }

        const populateViolations = () => {
            const drivers = submissionVM.lobData.personalUmbrella.coverables.vehicleOperators.value;
            violations = drivers ? drivers.flatMap((driver) => driver.disclosures.violations) : [];
        };

        const foundViolationsFromMVR = () => {
            return violations.some((v) => v.undisclosedActivity_ML === true);
        };

        const checkHIDriverMVR = () => {
            const drivers = submissionVM.lobData.personalUmbrella.coverables.vehicleOperators.value;
            if (drivers && checkHiDrivers(drivers) && checkPendingMvrOrderStatus(drivers)) {
                return true;
            }
            return false;
        }

        const getFormerCostsAndGoNext = () => {
            const costsAreEqual = (costA, costB) => {
                if (costA && costB) {
                    return costA.amount === costB.amount && costA.currency === costB.currency;
                }
                return true;
            };

            return new Promise((resolve) => {
                let premiumsMatch = false;

                const storagePromise = MLPortalStorageService.retrieve(submissionVM.quoteID.value, null, ML_STORAGE_KEY_PREVIOUS_PREMIUM);
                showProgressDialog(platformMessages.synchronizingQuote, storagePromise);
                storagePromise.then((response) => {
                    if (response) {
                        const formerCosts = JSON.parse(response);
                        const matchingQuote = formerCosts.find((quote) => { return quote.branchCode === selectedQuote.branchCode; });

                        if (matchingQuote) {
                            premiumsMatch = costsAreEqual(matchingQuote.monthlyPremium, selectedQuote.premium.monthlyPremium) || costsAreEqual(matchingQuote.total, selectedQuote.premium.total);
                        }
                    }
                });
                storagePromise.finally(() => {
                    MLDisclosureUtil.setRequoteAfterMvr(submissionVM.quoteID.value, true);
                    return resolve(!premiumsMatch);
                });
            });
        };

        populateViolations();
        if (foundViolationsFromMVR()) {
            return true;
        }
        if (checkHIDriverMVR()) {
            return true;
        }
        return getFormerCostsAndGoNext();
    }, [checkHiDrivers, checkPendingMvrOrderStatus, showProgressDialog, submissionVM]);
    
    const onNext = useCallback(async () => {
        const valid = submissionVM.aspects.valid && submissionVM.aspects.subtreeValid;

        if (!valid) {
            updateShowErrors(true);
            setErrorTimestamp(errorTimestamp+1);
            return false;
        }

        // validateEmailAndProceed
        const displayEmailAddressError = evaluateSpouseEmailAddressesInColorado() || evaluateDuplicatesInVehicleOperators();
        if (displayEmailAddressError) {
            clearBlockAlerts('duplicateEmailAddressError');
            addErrorAlert(messages.uniqueEmailAddAlert, 'uniqueEmailAddAlert');
            window.scrollTo(0,0);
            return false;
        }

        if (vehiclesVM.some((vehicle) => !vehicle.namedNonOwner_ML.value
            && isVehiclePrivateOrClassic(vehicle) && !isVinValid(vehicle))) {
            return false;
        }
        _.set(submissionVM, 'portalCurrentStep_ML.value', 'pupAddtlDetails');
        showProgressDialog(platformMessages.saveSubmission);
        try {
            if (!nextStepVisited()) {
                submissionVM.value = await LoadSaveService.updateQuotedSubmission(submissionVM.value);
                const shouldShowAdjustmentPage = await shouldShowDisclosures();
                if (!shouldShowAdjustmentPage) {
                    const index = _.findIndex(
                        steps,
                        ({path}) => path === '/adjustments'
                    );
                    if (index > 0) {
                        const remainingSteps = _.slice(steps, index + 1);
                        changeNextSteps(remainingSteps);
                    }
                } else {
                    const hasAdjustmentsStep = steps.some((step) => step.path === '/adjustments');
                    if (!hasAdjustmentsStep) {
                        const adjustmentIndex = _.findIndex(
                            wizardSteps, ({path}) => path === '/adjustments'
                        );
                        const nextSteps = _.slice(wizardSteps, adjustmentIndex);
                        changeNextSteps(nextSteps);
                    }
                }
            }
            return submissionVM;
        } finally {
            hideProgressDialog();
        }
    }, [addErrorAlert, changeNextSteps, clearBlockAlerts, errorTimestamp, evaluateDuplicatesInVehicleOperators, evaluateSpouseEmailAddressesInColorado, hideProgressDialog, isVinValid, shouldShowDisclosures, showProgressDialog, steps, submissionVM, vehiclesVM, wizardSteps]);

    const resolvers = {
        resolveComponentMap: {
            pupVehicleInfoComponent: PUPVehicleInfoComponent,
            pupAddtlInterestDriverComponent: PUPAddtlInterestDriverComponent,
            pupHouseholdDriverComponent: PUPHouseholdDriverComopnent,
            addtlInterestWatercraftOpComponent: AddtlInterestWatercraftOpComponent
        }
    };

    const overrides = {
        pupAdditionalInfoVehicleIterable: {
            data: vehiclesVM
        },
        additionalInfoRatedDriverIterable: {
            data: driversVM
        },
        additionalInfoExcludedDriverIterable: {
            data: excludedDriversVM
        },
        additionalInfoHouseholdDriverIterable: {
            data: householdMembersVM
        },
        additionalInfoWatercraftOperatorIterable: {
            data: watercraftOperatorsVM
        },
        additionalInterestList: {
            model: _.get(submissionVM, 'lobData.personalUmbrella.coverables.additionalInterests'),
            updateViewModel: updateSubmissionVM,
            onValueChange: writeValue,
            path: 'lobData.personalUmbrella.coverables',
            showValidationErrors: showErrors,
            onValidate,
            isPersonalUmbrella: true,
            additionalInterestAvailableCandidatesML
        },
        additionalInterestLossDivider:{
            visible:(_.get(submissionVM, 'lobData.personalUmbrella.coverables.additionalInterests.value').length>0),
        },
        liabilityLossVehicleOpIterable: {
            data: vehicleOperatorsVM
        },
        ...generateVehiclesOverrides(),
        ...generateDriversOverrides(),
        ...generateWatercraftOperatorsOverride(),
        ...generateLiabilityLossesOverride()
    };

    const getNextStepLabel = useCallback(() => {
        return (
            <FormattedMessage
                {...messages.nextStepLabel}
                values={{
                    purchaseDetails: <strong>{translator(messages.purchaseDetails)}</strong>
                }}
            />
        );
    }, [translator]);

    const skipOnResumeIf = () => {
        return !!_.get(submissionVM, 'bindData.policyNumber.value')
            && (submissionVM.value.baseData.status_ML === 'Bound' || submissionVM.value.baseData.status_ML === 'Binding');
    };

    return (
        <WizardPage
            onNext={onNext}
            skipWhen={skipOnResumeIf}
            showCancel={false}
            showPrevious={false}
            showTextNextToButton
            textNextToButton={getNextStepLabel()}
            nextLabel={translator(platformMessages.mlContinue)}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                overrideProps={overrides}
                model={submissionVM}
                onModelChange={updateWizardData}
                componentMap={resolvers.resolveComponentMap}
                callbackMap={resolvers.resolveCallbackMap}
                onValidationChange={onValidate}
                showErrors={showErrors}
            />
            <ScrollToError counter={errorTimestamp} />
        </WizardPage>
    );
}

PUPAdditionalInformationPreBindPage.propTypes = wizardProps;
export default PUPAdditionalInformationPreBindPage;
